<template>
    <div class="dropdown" v-if="team.length>0">
        <b-button-group>
            <button class="btn btn-white" :class="{ [customXStyle]: customXStyle }" @click="clear" v-if="localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown
                :variant="getButtonVariant"
                no-flip
                :text="label || $t( 'Staff')"
                :no-caret="isIconView"
                class="btn-link-reset"
                v-b-tooltip="{disabled: !isIconView }"
                :title="[ isIconView ? label || $t( 'Staff') : '' ]"
            >
                <template #button-content v-if="isIconView">
                    <span class="fe fe-users"></span>
                </template>
                <div
                    v-for="(member, index) in team"
                    :key="index"
                    :style="memberStyles(member.color)"
                    class="dropdown-item pl-3"
                >
                    <b-form-checkbox v-model="localValue" :value="member._id">
                        <avatar
                            type="circle"
                            v-if="member && member.avatar"
                            :src="member.avatar.preview"
                            size="avatar-xs"
                        ></avatar>
                        {{ member.firstName }}
                    </b-form-checkbox>
                </div>
            </b-dropdown>
        </b-button-group>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Avatar from '@/components/Avatar.vue'

export default {
    props: ['value', 'params', 'nullUser', 'isIconView', 'customXStyle'],
    components: {
        Avatar
    },
    data() {
        return {
            company: { firstName: this.$t('Company'), lastName: '', _id: null, avatar: 's' }
        }
    },
    computed: {
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find' }),

        localValue: {
            get() {
                return this.value
            },

            set(newValue) {
                this.$emit('input', newValue);
                this.$emit('change', newValue);
            }
        },

        label() {
            if (this.localValue && this.localValue.firstName) {
                return this.localValue.firstName + ' ' + this.localValue.lastName;
            } else {
                return false;
            }
        },
        team() {
            let data = this.findTeamInStore(this.params).data;
            if (this.nullUser)
                data.push(this.company);
            return data;
        },
        getButtonVariant() {
            return this.isIconView ? "link" : "white";
        }

    },
    methods: {
        clear() {
            this.localValue = [];
        },
        memberStyles(color) {
            return 'border-right:3px solid ' + color;
        },
        updateValue(teamMember) {
            this.localValue = teamMember;
        }

    }

}
</script>

<style lang="scss" scoped>
    .no-border {
        border-radius: 0;
        border: none;
        border-right: 2px solid #e4ebf7;
    }
</style>
